<template>
  <div class="white lighten-4">
    <v-container class="py-0 px-0 mx-0" fluid>
      <v-toolbar elevation="0" class="white" style="overflow-x: auto; overflow-y: hidden;">
        <v-toolbar-items>
          <v-btn
            link
            text
            :to="`/project/${$route.params.projectId}/market/${$route.params.marketId}/view`"
          >{{ $t('project.data_stall') }}</v-btn>
          <v-btn
            text
            link
            :to="`/project/${$route.params.projectId}/market/${$route.params.marketId}/customer`"
          >{{ $t('customer.customer_information') }}</v-btn>
          <v-btn
            text
            link
            :to="`/project/${$route.params.projectId}/market/${$route.params.marketId}/interest`"
          >{{ $t('area.area_interest') }}</v-btn>
          <v-btn
            text
            link
            :to="`/project/${$route.params.projectId}/market/${$route.params.marketId}/appeal`"
          >
            {{ $t('appeal.appeal') }}
            <v-icon class="alert-icon" color="error" v-if="isAppealWaitingStatus">mdi-alert-circle</v-icon>
          </v-btn>
          <v-btn
            text
            link
            :to="`/project/${$route.params.projectId}/market/${$route.params.marketId}/rental`"
          >{{ $t('market.collect_rental') }}</v-btn>
          <v-btn
            text
            link
            :to="`/project/${$route.params.projectId}/market/${$route.params.marketId}/accounting`"
          >{{ $t('market.accounting_document') }}</v-btn>
          <v-btn
            text
            link
            :to="`/project/${$route.params.projectId}/market/${$route.params.marketId}/approve`"
          >
            {{ $t('task.approve_list') }}
            <v-icon class="alert-icon" color="error" v-if="numberApproveWaitingStatus > 0">mdi-alert-circle</v-icon>
          </v-btn>

          <v-btn
            text
            link
            :to="`/project/${$route.params.projectId}/market/${$route.params.marketId}/report`"
          >{{ $t('market.summary_report') }}</v-btn>
          <v-btn
            text
            link
            :to="`/project/${$route.params.projectId}/market/${$route.params.marketId}/income-expense`"
          >{{ $t('market.income_expense') }}</v-btn>
          <v-btn
            text
            link
            :to="`/project/${$route.params.projectId}/market/${$route.params.marketId}/overall`"
          >{{ $t('project.analyse') }}</v-btn>
          <v-btn
            text
            link
            :to="`/project/${$route.params.projectId}/market/${$route.params.marketId}/setting`"
          >{{ $t('setup') }}</v-btn>
        </v-toolbar-items>
      </v-toolbar>
    </v-container>
  </div>
</template>

<script>
export default {
  name: "ParentBar",
  computed: {
    admin() {
      return this.$store.getters["admin/getByMarketId"](this.marketId);
    },
    marketId() {
      return this.$route.params.marketId;
    },
    isAppealWaitingStatus() {
      return this.$store.getters["appeal/getWaitingStatusByMarketId"];
    },
    numberApproveWaitingStatus() {
      return this.$store.getters["user/getApproveWaitingStatus"](this.marketId);
    }
  }
};
</script>

<style lang="scss" scoped>
.v-btn--text {
  color: #888 !important;
}
.v-btn--active {
  color: #000 !important;
  background-color: white !important;
  border-bottom: 3px solid #00a650;
}
.v-btn:before {
  background-color: white !important;
}
.v-btn {
  padding: 1rem;
}
.alert-icon {
  font-size: 18px !important;
}
</style>
